import React from 'react';
import PlatformIcon from './PlatformIcon';

function PlatformTopbar({ title, subtitle, actions }) {
  return (
    <header className="platform-topbar">
      <div>
        <h1>{title}</h1>
        {subtitle && <div className="platform-topbar-sub">{subtitle}</div>}
      </div>
      <div className="platform-topbar-actions">
        {actions}
        <div className="platform-search">
          <PlatformIcon name="search" size={17} />
          <span>Search contacts…</span>
        </div>
        <button type="button" className="platform-bell" aria-label="Notifications">
          <PlatformIcon name="bell" size={18} />
          <span className="platform-bell-dot" />
        </button>
      </div>
    </header>
  );
}

export default PlatformTopbar;
